import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function CheckThick({
  fillPrimary = colors.neutral10,
  className,
}: SvgIconCommonProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5068 3.44714C14.8121 3.72703 14.8328 4.20146 14.5529 4.5068L7.21954 12.5068C7.08482 12.6538 6.89714 12.741 6.69795 12.7494C6.49876 12.7577 6.30445 12.6863 6.15796 12.5511L2.49129 9.16649C2.18693 8.88554 2.16795 8.41104 2.4489 8.10668C2.72985 7.80231 3.20435 7.78333 3.50871 8.06429L6.62236 10.9384L13.4471 3.49321C13.727 3.18787 14.2015 3.16724 14.5068 3.44714Z"
        fill={fillPrimary}
        className="fill:#0B0C0E;fill:color(display-p3 0.0431 0.0471 0.0549);fill-opacity:1;"
      />
    </svg>
  );
}
